import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';

export interface InfoBoxProps {
  title?: string;
  children: React.ReactNode;
  closable?: boolean;
  severity?: 'info' | 'warning';
  onDismiss?: () => void;
}

export function InfoBox({
  title,
  children,
  closable = false,
  severity = 'info',
  onDismiss,
}: InfoBoxProps) {
  const borderColor =
    severity === 'info'
      ? 'info.main'
      : 'warning.main';

  const backgroundColor =
    severity === 'info'
      ? 'rgba(33, 150, 243, 0.04)'
      : 'rgba(255, 152, 0, 0.04)';

  return (
    <Paper
      sx={{
        borderLeft: 4,
        borderColor,
        backgroundColor,
        p: 2,
        mb: 2,
        position: 'relative',
      }}
    >
      {closable && (
        <IconButton
          size="small"
          onClick={onDismiss}
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <Close fontSize="small" />
        </IconButton>
      )}

      {title && (
        <Typography variant="subtitle2" fontWeight={700} gutterBottom>
          {title}
        </Typography>
      )}

      <Typography variant="body2">{children}</Typography>
    </Paper>
  );
}
